import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { PageHead, Panel, SButton, Empty } from "@/components/staff/Bits";

const KIND = { case: "Case", note: "Note", followup: "Follow-up", user: "User", gkk: "GKK", volunteer: "Volunteer offer", visit: "Home visit" };

export default function Trash() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => { api.get("/trash").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  useEffect(() => { load(); }, [load]);
  const restore = async (it) => {
    try { const { data } = await api.post(`/trash/${it.kind}/${it.id}/restore`); toast.success(data.note || "Restored"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-4xl">
      <PageHead title="Deleted items" sub="Deleted items are hidden everywhere but kept here so mistakes can be undone. Every deletion and restoration is recorded in the audit log." />
      <Panel className="p-0 sm:p-0 overflow-x-auto">
        {!items ? <Empty>Loading…</Empty> : items.length === 0 ? <Empty testid="trash-empty">Nothing has been deleted.</Empty> : (
          <table className="w-full text-[15px]" data-testid="trash-table">
            <thead className="bg-[#FAF8F5] text-left text-xs uppercase tracking-wider text-[#605349]"><tr><th className="px-4 py-3">Type</th><th className="px-4 py-3">Item</th><th className="px-4 py-3">Deleted</th><th className="px-4 py-3">Reason</th><th className="px-4 py-3" /></tr></thead>
            <tbody>{items.map((it) => (
              <tr key={`${it.kind}-${it.id}`} data-testid={`trash-row-${it.id}`} className="border-t border-[#EFE8DF]">
                <td className="px-4 py-3 font-semibold">{KIND[it.kind]}</td><td className="px-4 py-3">{it.label}</td>
                <td className="px-4 py-3 text-sm">{fmtDateTime(it.deleted_at)}<br />{it.deleted_by}</td><td className="px-4 py-3 text-sm">{it.reason}</td>
                <td className="px-4 py-3"><SButton variant="ghost" data-testid={`restore-${it.id}`} onClick={() => restore(it)}><RotateCcw className="w-4 h-4" /> Restore</SButton></td>
              </tr>))}</tbody>
          </table>)}
      </Panel>
    </div>
  );
}
